import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { AppsGatewaySwitcherTags } from './apps-gateway-switcher.types.ts';
import { getGlobalStyleSheets } from '../../global-styles';
import AtlAppsGatewaySwitcherItemStyles from './apps-gateway-switcher-item.scss?inline';

@customElement(AppsGatewaySwitcherTags.AppsGatewaySwitcherItem)
export class AtlAppsGatewaySwitcherItem extends LitElement {
   static styles = [
      ...getGlobalStyleSheets(),
      AtlAppsGatewaySwitcherItemStyles,
   ];

   render() {
      return html`
         <button type="button" class="dropdown-item switcher-item">
            <slot></slot>
         </button>
      `;
   }
}
